document.addEventListener('DOMContentLoaded', function() {
    const loader = document.getElementById('loader');
    const content = document.getElementById('content');
    
    // Delay in milliseconds (e.g., 3000ms = 3 seconds)
    const delay = 100;

    setTimeout(function() {
        loader.style.display = 'none';
        content.style.display = 'block';
    }, delay);
});